var map = {
	"./aws.svg": "ca6b",
	"./docker.svg": "0cb6",
	"./git.svg": "3ed8",
	"./github.svg": "70a1",
	"./html5.svg": "1291",
	"./java.svg": "ffcd",
	"./javascript.svg": "64b3",
	"./mongodb.svg": "476b",
	"./node.svg": "076d",
	"./postgresql.svg": "374f",
	"./python.svg": "4c36",
	"./rails.svg": "01a7",
	"./ruby.svg": "801c",
	"./slack.svg": "d660",
	"./vuejs.svg": "7528"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1361";